import React from 'react';
interface MeterMarkProps {
  size?: number;
  className?: string;
}
/**
 * Bespoke TokenMeter instrument mark: a semicircular gauge dial with
 * tick marks and a needle swept into the emerald "high spend" zone.
 * Built as a sharp, blueprint-style instrument to match the console identity.
 */
export function MeterMark({
  size = 24,
  className = ''
}: MeterMarkProps) {
  return <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} role="img" aria-label="TokenMeter gauge mark" data-id="element-183">
      {/* Outer dial track */}
      <path d="M4 22 A 12 12 0 0 1 28 22" stroke="currentColor" strokeOpacity="0.3" strokeWidth="2.5" strokeLinecap="square" data-id="element-184" />
      {/* Active emerald sweep (right portion of the dial = high spend) */}
      <path d="M16 10 A 12 12 0 0 1 28 22" stroke="#10b981" strokeWidth="2.5" strokeLinecap="square" style={{
      filter: 'drop-shadow(0 0 3px rgba(16,185,129,0.6))'
    }} data-id="element-185" />
      {/* Tick marks */}
      <line x1="4" y1="22" x2="6.2" y2="21" stroke="currentColor" strokeOpacity="0.5" strokeWidth="1.5" data-id="element-186" />
      <line x1="16" y1="10" x2="16" y2="12.4" stroke="currentColor" strokeOpacity="0.5" strokeWidth="1.5" data-id="element-187" />
      <line x1="28" y1="22" x2="25.8" y2="21" stroke="currentColor" strokeOpacity="0.5" strokeWidth="1.5" data-id="element-188" />
      {/* Needle pointing into the emerald zone */}
      <line x1="16" y1="22" x2="23" y2="15" stroke="#10b981" strokeWidth="2.5" strokeLinecap="square" data-id="element-189" />
      {/* Hub */}
      <rect x="13.5" y="19.5" width="5" height="5" fill="#10b981" data-id="element-190" />
    </svg>;
}